import { render, staticRenderFns } from "./EditSurveyQuestion.vue?vue&type=template&id=1efbf538&scoped=true&"
import script from "./EditSurveyQuestion.vue?vue&type=script&lang=js&"
export * from "./EditSurveyQuestion.vue?vue&type=script&lang=js&"
import style0 from "./EditSurveyQuestion.vue?vue&type=style&index=0&id=1efbf538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efbf538",
  null
  
)

export default component.exports